import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import './TransactionStatusScreen.scss'
import TransactionSuccess from './components/TransactionSuccess/TransactionSuccess'
import TransactionFailed from './components/TransactionFailed/TransactionFailed'
import { Link } from 'react-router-dom'
import { routingService } from 'app_services/routingService'
import TransactionPending from './components/TransactionPending/TransactionPending'
import TransactionService from 'app_services/transaction/transactionService'
import { useParams } from 'react-router-dom'
import { ITransactionStatus, TransactionStatus } from 'app_types/transaction/transactionTypes'
import TransactionNotFound from './components/TransactionNotFound/TransactionNotFound'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index'

const DELAY_REQUEST = 2000
const icontecIcon = require('app_assets/images/logos/icontec.png')

const TransactionStatusScreen: FC = () => {

  const transactionService = useMemo(() => new TransactionService(), [])
  const { transactionId } = useParams<{transactionId: string}>()
  const [transaction, setTransaction] = useState<ITransactionStatus>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const user = useSelector((state: CombinedReducers) => state.auth?.user?.data)
  const formatCOP = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
  });

  const getTransaction = useCallback(async () => {
    setIsLoading(true)
    setTimeout(async () => {
      try {
        const response = await transactionService.getById(transactionId, true)
        if (response?.code === 200) {
          setTransaction(response.transaction)
        }
        setIsLoading(false)
      } catch {
        // Do nothing
      }
    }, [DELAY_REQUEST])
  }, [transactionId, transactionService])

  useEffect(() => {
    getTransaction()
  }, [getTransaction])

  const getPaymentDetails = () => {
    if (transaction?.shoppingCartItems && transaction?.shoppingCartItems.length > 0) {
      const courseListNames = transaction.shoppingCartItems.map(item => (<li>{item.description} ({item.numberOfPlaces})</li>))
      return (
        <>
          <div className='transactions-success--text-information'><b>Productos:</b> {courseListNames}</div>
          <div className='transactions-success--text-information'><b>Nombre:</b> {transaction?.billingInfo?.fullName}</div>
          <div className='transactions-success--text-information'><b>Correo:</b> {transaction?.billingInfo?.email}</div>
          <div className='transactions-success--text-information'><b>CC:</b> {transaction?.billingInfo?.docNumber}</div>
          <div className='transactions-success--text-information'><b>Valor:</b> {formatCOP.format(transaction?.totalAmount ? transaction?.totalAmount : 0)}</div>
        </>
      )
    } else if (transaction?.certificateQueue) {
      return (
        <>
          <div className='transactions-success--text-information'>Certificado: {transaction?.certificateQueue?.certificateSetting?.certificateName}</div>
          <div className='transactions-success--text-information'>Nombre: {transaction?.certificateInfo?.fullName}</div>
          <div className='transactions-success--text-information'>Correo: {user?.email}</div>
          <div className='transactions-success--text-information'>CC: {transaction?.certificateInfo?.docNumber}</div>
          <div className='transactions-success--text-information'>Valor: {formatCOP.format(transaction?.totalAmount ? transaction?.totalAmount : 0)}</div>
        </>
      )
    } else {
      return (
        <>
          <div className='transactions-success--text-information'>Valor: {formatCOP.format(transaction?.totalAmount ? transaction?.totalAmount : 0)}</div>
        </>
      )
    }
  }

  return (
    <div className='transaction-status-screen--container'>
      <div className='transaction-status-screen--container-icon'>
        <Link to={routingService.getPublicPath()}>
          <img className='transaction-status-screen--image' src={icontecIcon} alt="" />
        </Link>
      </div>
      {transaction?.status === TransactionStatus.SUCCESS && (
        <TransactionSuccess transaction={transaction} isLoading={isLoading} handleGetDetails={getPaymentDetails} />
      )}
      {transaction?.status && [TransactionStatus.CANCELLED, TransactionStatus.ERROR, TransactionStatus.REJECTED, TransactionStatus.REVERSED].includes(transaction?.status) && (
        <TransactionFailed transaction={transaction} isLoading={isLoading} handleGetDetails={getPaymentDetails} />
      )}
      {(isLoading || (transaction?.status && [TransactionStatus.IN_PROCESS].includes(transaction?.status))) && (
        <TransactionPending transaction={transaction} isLoading={isLoading} handleGetDetails={getPaymentDetails} />
      )}
      {!isLoading && !transaction && (
        <TransactionNotFound />
      )}
    </div>

  )
}

export default TransactionStatusScreen
